__turbopack_context__.v({
  "buttons": "home-client-module___Uyn6q__buttons",
  "gradientOverlay": "home-client-module___Uyn6q__gradientOverlay",
  "subtitle": "home-client-module___Uyn6q__subtitle",
  "textStack": "home-client-module___Uyn6q__textStack",
  "title": "home-client-module___Uyn6q__title",
});
